<script lang="ts">
    import type { SubPoint } from "../../../../../types/global"
    import GoogleMaps from "./GoogleMaps.svelte"
    import { openedElements } from "../../../store"
    import changeOpenedElement from "../../functions/changeOpenElement"
    import Person from "./Person.svelte"
    import Text from "./Text.svelte"
    export let footer = false
    export let i: number
    export let rowI: number
    export let subPoint: SubPoint
    let contentContainer: any = false
    let opened = false
    $: opened = contentContainer == $openedElements.subPoint
</script>

<div class="container">
    <div
        class="title-row"
        on:keydown
        on:click="{(e) => {
            console.log('test32')
            $openedElements = changeOpenedElement(contentContainer, 'subPoint', footer, subPoint.id)
        }}"
        id="trowNr-{rowI}-tsubPointNr-{i}"
    >
        <div class="max-width-container">
            <button class="{`opener ${opened ? 'opened' : 'closed'}`}"
                ><img src="{`/media/chevron-${opened ? 'up.svg' : 'down.svg'}`}" alt="chev" /></button
            >
            <h3 class="title">{subPoint.title}</h3>
        </div>
    </div>

    <div
        class="{`content-container collapsible-wrapper ${opened ? 'content-shown' : 'collapsed'}`}"
        bind:this="{contentContainer}"
        id="rowNr-{rowI}-subPointNr-{i}"
    >
        <div class="collapsible">
            <div class="line"></div>
            {#if subPoint.contentType == "googleMaps"}
                <GoogleMaps />
            {:else}
                <Text subPoint="{subPoint}" />
            {/if}
        </div>
    </div>
</div>

<style lang="less">
    @import "../../assets/css/variables.less";
    @import "../../assets/css/collapse.less";
    .container {
        margin-bottom: 2px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title-row {
            background-image: linear-gradient(to bottom, #bbbfc7 0%, rgba(91, 103, 126, 0) 100%);
            width: 100%;
            display: flex;
            cursor: pointer;
            justify-content: center;
            .max-width-container {
                width: 100%;
                max-width: @max-width;

                @media @mobile {
                    padding: 0px calc(@default-padding / 1.5);
                }
                @media @tablet {
                    padding: 0px @default-padding;
                }
                height: 40px;
                gap: 40px;
                display: flex;
                align-items: center;

                .opened {
                    background-color: @main-selected;
                }

                .closed {
                    background-color: @font-footer;
                }

                .opener {
                    @media @mobile {
                        width: 40px !important;
                    }
                    @media @tablet {
                        width: 80px !important;
                    }
                    height: 40px;
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        transform: scale(2);
                        transform-origin: center;
                    }
                }
            }
        }

        .content-container,
        .collapsible {
            width: 100%;
            @media @mobile {
                padding: 0px calc(@default-padding / 3);
            }
            @media @tablet {
                padding: 0px calc(@default-padding / 2);
            }
            display: flex;
            align-items: stretch;
            max-width: @max-width;
            .line {
                flex-shrink: 0;
                @media @mobile {
                    width: 40px !important;
                }
                @media @tablet {
                    width: 80px !important;
                }

                background-color: @main-bright;
            }
        }
    }
</style>
